import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import PropTypes from "prop-types";
import * as fromRoutes from "../actions/types";

// components
import EquipmentList from "./equipment-list-container";
import EquipmentDetail from "./equipment-container";

const EquipmentRoutes = ({ onGetEquipmentList }) => {
	useEffect(() => {
		onGetEquipmentList();
	}, [onGetEquipmentList]);

	return (
		<Switch>
			<Route exact path={fromRoutes.EQUIPMENT_ROUTE} component={EquipmentList} />
			<Route path={fromRoutes.EQUIPMENT_MEMBER_ROUTE} component={EquipmentDetail} />
		</Switch>
	);
};

EquipmentRoutes.propTypes = {
	onGetEquipmentList: PropTypes.func.isRequired,
};

export default EquipmentRoutes;
